import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Size, Color } from '../../const'

export const TextInput = ({
  label,
  type,
  value,
  maxLength,
  name,
  width,
  height,
  onChange,
  onBlur,
  errorMessage,
  placeholder,
  ariaLabel,
}) => (
  <Wrapper>
    {label && <Label>{label}</Label>}
    <InputGroup>
      <InputStyle
        width={width}
        height={height}
        type={type}
        name={name}
        value={value}
        maxLength={maxLength}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        aria-label={ariaLabel}
      />
      <Error>{errorMessage}</Error>
    </InputGroup>
  </Wrapper>
)

const Wrapper = styled.div`
  display: inline-flex;
  width: 100%;
  padding: 8px 0;
`

const InputGroup = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`

const Label = styled.label`
  width: 30%;
  padding-right: 30px;
  text-align: right;
  vertical-align: top;
  font-size: ${Size.FONT.LABEL};
`

const InputStyle = styled.input`
  padding: 12px 16px;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  vertical-align: top;
  text-align: left;
  background-color: #fff;
  font-size: 16px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.63;
  letter-spacing: 0.21px;
  border: solid 1px ${Color.LINE.POWER_BLUE};
  border-radius: 5px;
  &::placeholder {
    color: ${Color.FONT.ANNOTATION};
  }
`

const Error = styled.div`
  color: ${Color.FONT.DANGER};
`

TextInput.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  maxLength: PropTypes.string,
  name: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  errorMessage: PropTypes.object,
  placeholder: PropTypes.string,
  ariaLabel: PropTypes.string,
}
